import React from "react";
import { Collapse } from "antd";
import styled from "styled-components";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

const { Panel } = Collapse;

const CollapseA = styled(Collapse)`
  border-bottom: 0 !important;
  .ant-collapse-header {
    font-size: 1.5rem;
    color: white !important;
    background-color: #1196dd;
  }
  .ant-collapse-arrow {
    right: 1rem;
    left: auto;
  }
`;

const PanelX = styled(Panel)`
  margin-bottom: 1rem;
  overflow: hidden;
  background: #f7f7f7;
  border: 0px;
  border-radius: 2px;
  .text {
    margin-bottom: 0;
    font-size: 1.2rem;
    padding-top: 0.5rem;
  }
`;

const collapseData = [
  {
    key: 1,
    title: "3D Designers",
    content:
      "Publish your 3D models and share them for free or at a cost! If your designs are not free, for each sale, you will receive 85% of the net selling price. If you publish your files for free, simply select the Creative Commons license.",
  },
  {
    key: 2,
    title: "Printer Owners",
    content:
      "Sign up your printers and enter the Colors and Materials you have available. Set the cost per gram for example 10c per gram. Earn 85% of the net selling price when you complete jobs on the platform!",
  },
  {
    key: 3,
    title: "Print Customers",
    content:
      "Publish your photos and show the quality of your 3D prints. Share pictures of your 3D printed objects, indicate which 3Dprintit hub you have used, the your 3D printing settings and how you did the post-production.",
  },
  {
    key: 4,
    title: "How are customers protected on the platform?",
    content:
      "Money paid to printer accounts is held in escrow for 30 days. It is released when the buyer has marked the print delivered and are happy with the print quality.",
  },
  {
    key: 5,
    title: "What is the base currency?",
    content: "$AUD",
  },
  {
    key: 6,
    title: "What colour filament am I looking for?",
    content: "https://filamentcolors.xyz/library/",
  },
  {
    key: 7,
    title: "My money for printing has not been released yet?",
    content:
      "Printer should ask the buyer to change the status of the order to 'Received' from the Orders page after they have marked their product as 'Delivered', if they want to receive money before 30 days. If the status is not changed to Received until 30 days after payment, it will be automatically released to printer.",
  },
  {
    key: 8,
    title: "Service Fee",
    content:
      "We charge a flat $5 service fee to the customer for each print, of which $2.50 is passed onto the printer hub.",
  },
];

const CollapseB = () => {
  return (
    <div style={{ height: "100%" }}>
      <CollapseA
        accordion
        bordered={false}
        expandIconPosition="right"
        expandIcon={({ isActive }) =>
          isActive ? (
            <MinusOutlined style={{ fontSize: "1.5rem" }} />
          ) : (
            <PlusOutlined style={{ fontSize: "1.5rem" }} />
          )
        }
      >
        {collapseData.map((s) => {
          return (
            <PanelX header={s.title} key={s.key}>
              {/* <p className='text'>{s.content}</p> */}
              {s.content.includes("https://") ? (
                <a href={s.content} className="text">
                  {s.content}
                </a>
              ) : (
                <p className="text">{s.content}</p>
              )}
            </PanelX>
          );
        })}
      </CollapseA>
    </div>
  );
};

export default CollapseB;
